import React from "react";
import { FormattedMessage } from "react-intl";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import PropTypes from "prop-types";
import AlmigProgressBar from "../grundelemente/AlmigProgressBar";
import InfoBlock from "../grundelemente/InfoBlock";
import InfoDateContainer from "../grundelemente/InfoDateContainer";
import InfoPanel from "../grundelemente/InfoPanel";
import UnitValueContainer from "../einheiten/UnitValueContainer";
import UnitTextContainer from "../einheiten/UnitTextContainer";
import { masterDisplayedStatusTNR } from "../model/Verbund";

const VerbundInfoPanel = props => (
	<InfoPanel>
		<InfoBlock>
			<FormattedMessage id="Actual system pressure" /><br />
			<UnitValueContainer unit="pressure" value={props.master.system_pressure_bar} />
			<span>{" "}</span><UnitTextContainer unit="pressure" />
		</InfoBlock>
		<InfoBlock>
			<FormattedMessage id="Load factor" /><br />
			<AlmigProgressBar value={props.master.load_factor_percent} />
		</InfoBlock>
		<OverlayTrigger placement="bottom" overlay={
			<Tooltip id="volume_flow">
				<FormattedMessage id="Consumed compressed air" />
			</Tooltip>}>
			<div>
				<InfoBlock>
					<FormattedMessage id="Station volume flow" /><br />
					<UnitValueContainer unit="volume_over_minutes" value={props.master.volume_flow_m3min} />
					<span>{" "}</span><UnitTextContainer unit="volume_over_minutes" />
				</InfoBlock>
			</div>
		</OverlayTrigger>
		<OverlayTrigger placement="bottom" overlay={
			<Tooltip id="delivery_volume">
				<FormattedMessage id="Generated compressed air" />
			</Tooltip>}>
			<div>
				<InfoBlock>
					<FormattedMessage id="Station delivery volume" /><br />
					<UnitValueContainer unit="volume_over_minutes" value={props.master.delivery_volume_m3min} />
					<span>{" "}</span><UnitTextContainer unit="volume_over_minutes" />
				</InfoBlock>
			</div>
		</OverlayTrigger>
		<InfoBlock>
			<FormattedMessage id="Energy consumption" /><br />
			<UnitValueContainer unit="power" value={props.master.energy_consumption_kW} />
			<span>{" "}</span><UnitTextContainer unit="power" />
		</InfoBlock>
		<InfoBlock>
			<FormattedMessage id="State" /><br />
			<FormattedMessage id={ masterDisplayedStatusTNR(props.master) } />
		</InfoBlock>
		<InfoDateContainer />
	</InfoPanel>
);

VerbundInfoPanel.propTypes = {
	master: PropTypes.object.isRequired
};

export default VerbundInfoPanel;
